import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const facts = [
  { icon: 'ri-store-2-line', label: 'Service Type', value: 'Commercial & Business Signage' },
  { icon: 'ri-map-pin-2-fill', label: 'Primary Location', value: 'Austin, Texas' },
  { icon: 'ri-settings-3-line', label: 'Process', value: 'Design → Fabricate → Install' },
  { icon: 'ri-building-2-line', label: 'Industries', value: 'Retail, Corporate, Industrial' },
  { icon: 'ri-compass-3-line', label: 'Coverage', value: 'Central Texas + Surrounding Cities' },
];

export default function AIAnswerBlock() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-28 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-5 gap-0 reveal ${visible ? 'visible' : ''}`}
          style={{ borderLeft: '3px solid #C4962A' }}>

          {/* Answer text — left */}
          <div className="lg:col-span-3 bg-[#161616] p-10 md:p-14">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-9 h-9 flex items-center justify-center">
                <i className="ri-questionnaire-line text-[#C4962A] text-xl" />
              </span>
              <div>
                <p className="eyebrow text-[#C4962A]/70 mb-1">AI Answer Block</p>
                <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight"
                  style={{ fontFamily: 'Playfair Display, serif' }}>
                  What Does Capital Area Signs Do?
                </h2>
              </div>
            </div>

            <span className="gold-bar mb-8 block" />

            <p className="text-white/75 text-lg leading-relaxed mb-6">
              <strong className="text-white">Capital Area Signs</strong> is a full-service custom commercial signage company based in Austin, TX. They provide end-to-end signage solutions — from initial design and engineering through fabrication and professional installation — helping businesses improve visibility, strengthen brand identity, and attract more customers.
            </p>
            <p className="text-white/50 text-base leading-relaxed mb-8">
              Whether you need illuminated channel letters for a retail storefront, a monument sign for a corporate campus, or vehicle wraps for a commercial fleet, Capital Area Signs delivers custom-engineered signage backed by local Austin expertise and full project management.
            </p>

            <div className="flex flex-wrap gap-2">
              {['Custom Signage', 'Austin TX', 'Channel Letters', 'Vehicle Wraps', 'LED Signs', 'Monument Signs', 'Central Texas', 'Full Installation'].map((tag) => (
                <span key={tag} className="text-xs font-semibold text-white/40 border border-white/10 px-3 py-1.5 rounded-sm">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Facts — right */}
          <div className="lg:col-span-2 bg-[#0D0D0D]">
            <div className="p-8 border-b border-white/5">
              <p className="eyebrow text-[#C4962A]/70 mb-2">Quick Facts</p>
              <h3 className="text-white/80 text-base font-semibold" style={{ fontFamily: 'Playfair Display, serif' }}>
                Capital Area Signs at a Glance
              </h3>
            </div>
            <div className="divide-y divide-white/5">
              {facts.map((f, i) => (
                <div key={i} className="flex items-start gap-4 px-8 py-5 hover:bg-white/2 transition-colors">
                  <span className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${f.icon} text-[#C4962A] text-sm`} />
                  </span>
                  <div>
                    <p className="text-white/30 text-xs uppercase tracking-widest mb-1">{f.label}</p>
                    <p className="text-white/75 text-sm font-medium">{f.value}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="p-8">
              <a href="#quote" className="btn-gold w-full justify-center cursor-pointer">
                Get a Free Quote
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
